export const LOGIN_FETCH_OPERATOR_INFO = 'LOGIN_FETCH_OPERATOR_INFO'
export const LOGIN_SET_SESSION_OBJ = 'LOGIN_SET_SESSION_OBJ'
